import script from "./UserPaymentUpdateCheckout.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPaymentUpdateCheckout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__